// removed by extract-text-webpack-plugin
module.exports = {"component":"UWg_K0k8rxlm0AU950eyO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Locale/locale.css
// module id = 1080
// module chunks = 2